import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ImageGalleryUploader from 'components/ImageGalleryUploader';
import { v1 as uuidv1 } from 'uuid';
import DataForm from 'forms/DataForm';
import { request } from 'utilities/graph';
import { createUrlSetting, updateUrlSetting } from 'graphql/mutations';
import schema from './schema.js';
import uiSchema from './uiSchema';
import { getClientIdSchema } from 'forms/schemas';
import { useCache } from 'CacheProvider';

export default function UrlSettingsForm({ formData: inFormData, ...props }) {
  const { appGroup } = useCache();
  const [currentId, setCurrentId] = useState(uuidv1());
  const [currentTitleImageS3Keys, setCurrentTitleImageS3Keys] = useState([]);

  useEffect(() => {
    if (inFormData?.titleImageS3Keys) {
      setCurrentTitleImageS3Keys(inFormData.titleImageS3Keys);
    }
    if (inFormData?.id) {
      setCurrentId(inFormData.id);
    }
  }, [inFormData]);

  const createFunc = async (data) => {
    data.id = currentId;
    data.titleImageS3Keys = currentTitleImageS3Keys;
    await request(createUrlSetting, { input: data });
  };

  const updateFunc = async (data) => {
    data.titleImageS3Keys = currentTitleImageS3Keys;
    await request(updateUrlSetting, { input: data });
  };

  return (
    <DataForm
      schema={schema}
      uiSchema={uiSchema}
      createFunc={createFunc}
      updateFunc={updateFunc}
      formData={inFormData}
      dirty={true}
      extMappings={[{
        key: 'clientId',
        func: (clientId) => {
          const adminMode = appGroup === 'Admins';
          return getClientIdSchema(clientId, '所屬機構', false, adminMode, false);
        },
      }]}
      {...props}
    >
      <Typography variant="h5" style={{ marginTop: 16 }}>
        標題圖片
      </Typography>
      <Typography variant="body2" color='textSecondary'>
        建議尺寸 1368 x 445
      </Typography>
      <Divider />
      <ImageGalleryUploader
        s3Prefix={`urlSettings/${currentId}/titleImage`}
        s3Keys={currentTitleImageS3Keys}
        onUpdateS3Keys={setCurrentTitleImageS3Keys}
      />
    </DataForm>
  );
}

UrlSettingsForm.propTypes = {
  data: PropTypes.object,
  formData: PropTypes.object,
  onComplete: PropTypes.func,
};
